import React from "react";
import "../About/About.css";
import office1 from "../../../ReactKaamvalaWebsite/assets/image/office1.webp";
import office2 from "../../../ReactKaamvalaWebsite/assets/image/office2.webp";
import office3 from "../../../ReactKaamvalaWebsite/assets/image/office3.webp";
import member1 from "../../../ReactKaamvalaWebsite/assets/image/member1.svg";
import member2 from "../../../ReactKaamvalaWebsite/assets/image/member2.svg";
import member3 from "../../../ReactKaamvalaWebsite/assets/image/member3.svg";
import member4 from "../../../ReactKaamvalaWebsite/assets/image/member4.svg";
import member5 from "../../../ReactKaamvalaWebsite/assets/image/member5.svg";
import member6 from "../../../ReactKaamvalaWebsite/assets/image/member6.svg";
import milestone from "../../../ReactKaamvalaWebsite/assets/image/milestone.svg";
import milestone2 from "../../../ReactKaamvalaWebsite/assets/image/milestone2.svg";
import locate from "../../../ReactKaamvalaWebsite/assets/icon/locate.svg";
import email from "../../../ReactKaamvalaWebsite/assets/icon/email_contact.svg";
import playstore from "../../../ReactKaamvalaWebsite/assets/icon/playstore.svg";
import ios from "../../../ReactKaamvalaWebsite/assets/icon/iso.svg";
import mobile from "../../../ReactKaamvalaWebsite/assets/image/mobile.webp";

const About = () => {
  return (
    <>
      <div id="about-section">
        <section className="about-section">
          <div className="container my-5">
            <div className="vision text-center">
              <h4 className="text-center text-heading1 my-4">About Kaamvala</h4>
            </div>
            <div className="container">
              <div className="row d-flex justify-content-center mx-auto">
                <div className="col-md-7 px-1">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="about-us-img-container">
                        <img
                          src={office1}
                          className="d-block img-fluid w-100"
                          width="702"
                          height="362"
                          alt="web and  app development"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="about-us-img-container w-100">
                        <img
                          src={office2}
                          alt="web and app development"
                          width="702"
                          height="362"
                          className="d-block img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-5 px-1">
                  <div className="about-us-img-container w-100">
                    <img
                      src={office3}
                      className="d-block img-fluid"
                      alt="web  and app development"
                      width="553"
                      height="656"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <section id="foundation">
        <div className="container">
          <div className="kaamwala_description py-5">
            <h3>
              Kaamvala was founded in 2023 as a direct hiring application.
            </h3>
            <p className="text-center">
              Kaamvala is a top hiring app designed to connect skilled people
              with growing companies. Our goal is tKaamvala was founded in 2018
              as a direct hiring application.o make hiring easy by connecting
              recruiters and candidates online through our top hiring app.
            </p>
            <p className="text-center">
              Our top hiring app uses smart technology to help recruiters find
              the right people fast. This saves time and improves the hiring
              process. We match job seekers with the right employers based on
              their skills and experience using our top hiring app.
            </p>
            <p className="text-center">
              With Kaamvala, the top hiring app, you can chat and video call
              directly with recruiters. No need for long email exchanges. Our
              top hiring app has helped over 3 million job seekers connect with
              190,000 recruiters.
            </p>
            <p className="text-center">
              Our top hiring app makes communication easy and quick. Job seekers
              can showcase their skills and talk to recruiters in real-time.
              Recruiters get real-time recommendations and detailed profiles,
              making it easier to find the best candidates using our top hiring
              app.
            </p>
            <p className="text-center">
              We are changing how hiring works with our top hiring app. Our app
              helps recruiters find the right talent quickly. We provide
              real-time suggestions and useful data to improve hiring. Our goal
              is to make the hiring process smooth and efficient for everyone
              using our top hiring app.
            </p>
          </div>
        </div>
      </section>
      <section id="Team-member">
        <div className="container py-4">
          <div className="col-md-12">
            <h4 className="text-center member my-4">Meet The Team</h4>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-4">
              <div className="about-us-img-container-team d-flex justify-content-center mx-auto">
                <img
                  src={member1}
                  width="300"
                  height="300"
                  className="d-block img-fluid"
                  alt="web and app development"
                />
              </div>
              <div className="vision text-center">
                <h5 className="text-center">Shobi khan</h5>
                <p className="text-center">Founder</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="about-us-img-container-team d-flex justify-content-center mx-auto">
                <img
                  src={member2}
                  width="300"
                  height="300"
                  className="d-block img-fluid"
                  alt="web and app development"
                />
              </div>
              <div className="vision text-center">
                <h5 className="text-center">Javed khan</h5>
                <p className="text-center">Co-Founder</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="about-us-img-container-team d-flex justify-content-center mx-auto">
                <img
                  src={member3}
                  width="300"
                  height="300"
                  className="d-block img-fluid"
                  alt="web and app development"
                />
              </div>
              <div className="vision text-center">
                <h5 className="text-center">Heena khan</h5>
                <p className="text-center">Business Advisor</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="about-us-img-container-team d-flex justify-content-center mx-auto">
                <img
                  src={member4}
                  width="300"
                  height="300"
                  className="d-block image-fluid"
                  alt="web and app development"
                />
              </div>
              <div className="vision text-center">
                <h5 className="text-center">Afjal Khan</h5>
                <p className="text-center">Tech Head</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="about-us-img-container-team d-flex justify-content-center mx-auto">
                <img
                  src={member5}
                  width="300"
                  height="300"
                  className="d-block image-fluid"
                  alt="web and app development"
                />
              </div>
              <div className="vision text-center">
                <h5 className="text-center">Shakir Khan</h5>
                <p className="text-center">Delivery Head</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="about-us-img-container-team d-flex justify-content-center mx-auto">
                <img
                  src={member6}
                  width="300"
                  height="300"
                  className="d-block image-fluid"
                  alt="web and app development"
                />
              </div>
              <div className="vision text-center">
                <h5 className="text-center">Charu Rajput</h5>
                <p className="text-center">Service Head</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="milestone">
        <div className="container py-5">
          <div className="col-md-12">
            <h4 className="text-center milestone py-3 mb-4">Milestones</h4>
          </div>
          <div className="row">
            <div className="col-md-6 d-flex justify-content-end py-2">
              <div className="about-us-img-milestones d-flex m-auto align-items-center">
                <div className="row">
                  <div className="col-md-5 justify-content-center m-auto d-flex ">
                    <div className="milestone_icons">
                      <img
                        src={milestone}
                        className="d-block image-fluid"
                        width="120"
                        height="120"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-7 justify-content-center m-auto">
                    <div className="milestone_content justify-content-center mx-auto px-2">
                      <h3 id="recruiters">100k+</h3>
                      <h6>Verified Recruiters</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-end py-2">
              <div className="about-us-img-milestones d-flex m-auto align-items-center">
                <div className="row">
                  <div className="col-md-5 justify-content-center m-auto d-flex ">
                    <div className="milestone_icons">
                      <img
                        src={milestone2}
                        className="d-block image-fluid"
                        width="120"
                        height="120"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-7 justify-content-center m-auto">
                    <div className="milestone_content justify-content-center mx-auto px-2">
                      <h3 id="recruiters">1.5M+</h3>
                      <h6>Verified Recruiters</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="location">
        <div className="container py-5">
          <div className="row">
            <div className="col-md-12 col-lg-6">
              <div className="map_container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d112071.96988686615!2d77.28368769256504!3d28.622296684093907!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x390d23cf92469f0b%3A0x436f50edc9a68f84!2s7th%20Floor%2C%20TOWER-C%2C%20Noida%20One%2C%20Unit%20C-720%2C%20Plot%20No.%208%2C%20Block%20B%2C%20Noida%2C%20Uttar%20Pradesh%20201309!3m2!1d28.6223216!2d77.3660891!5e0!3m2!1sen!2sin!4v1729660352250!5m2!1sen!2sin"
                  frameborder="0"
                  width="550"
                  height="500"
                  className="map"
                  style={{
                    border: "0",
                  }}
                ></iframe>
              </div>
            </div>
            <div className="col-md-12 col-lg-6 align-items-center my-auto">
              <div>
                <h4 className="text-left head-text py-3 d-flex px-3">
                  Head Office
                </h4>
              </div>
              <div className="container">
                <div className="headoffice_details d-flex my-3">
                  <img
                    src={locate}
                    className="image-fluid d-block"
                    alt="web and development"
                    width="30"
                    height="30"
                  />
                  <p className="justify-content-center my-auto px-3">
                    7th Floor, TOWER-C, Noida One, Unit C-720,Plot No.8,Block B,
                    Noida, Uttar Pradesh 201309
                  </p>
                </div>
                <div className="headoffice_details d-flex my-3">
                  <img
                    className="d-flex image-fluid"
                    src={email}
                    alt="web and development"
                    width="30"
                    height="30"
                  />
                  <p className="justify-content-center my-auto px-3">
                    info@kaamvala.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="download">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-6">
              <div className="my-3 mobile-image">
                <img
                  src={mobile}
                  className="d-block img-fluid"
                  alt="web and app development"
                  width="602"
                  height="574"
                />
              </div>
            </div>
            <div
              className="col-md-6 col-lg-6 justify-content-center align-items-center m-auto d-flex
            "
            >
              <div className="row">
                <div className="col-md-12">
                  <div className="get_the_app">
                    <h4 className="text-left get-app-text py-3">
                      Get the Kaamvala app
                    </h4>
                    <p className="click">
                      Click the button below to download the kaamvala app.
                    </p>
                  </div>
                </div>
                <div className="col-md-12 d-flex m-auto justify-content-around all_button pl-0 ">
                  <div className="app_buttons_playstore d-flex">
                    <img
                      src={playstore}
                      className="d-block img-fluid w-100"
                      alt="web and app development"
                      width="200"
                      height="60"
                    />
                  </div>
                  <div className="app_buttons_playstore d-flex">
                    <img
                      src={ios}
                      className="d-block img-fluid w-100"
                      width="200"
                      height="60"
                      alt="web and app development"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default About;
